import Vue from 'vue';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'Stores',
  components: {
    StoreComp: require('./store.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      stores: [],
      warehouses: [],
      inventories: [],
      inventoryGroups: [],
      bStoreDialog: false,
      bConfirmDialog: false,
      deleteConfirmMessage: '',
      editingStore: {},
      editingStoreClone: {},
      message: ''
    };
  },
  created() {
    //console.log("stores data", this.dataObj)
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('om_jobcard_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.dataObj.appData.stores.forEach((p) => {
          if (!p.uuid || p.uuid.length === 0) p.uuid = uuidv4();
        });
        if (this.dataObj.appData.stores) this.stores = this.dataObj.appData.stores;
        else this.dataObj.appData.stores = [];
        this.warehouses = this.dataObj.appData.warehouses;
        this.filterInventories();
      });
    },
    filterInventories() {
      this.inventories = this.dataObj.appData.inventories.filter((p) => p.inventoryType == 0);
      if (!this.inventories || this.inventories.length == 0) {
        this.inventoryGroups = [];
        return;
      }

      let groupIds = this.inventories.map((i) => i.groupId);
      let uniqueGroupIds = groupIds.filter((value, index) => groupIds.indexOf(value) === index);
      this.inventoryGroups = this.dataObj.appData.inventoryGroups.filter((item) => uniqueGroupIds.includes(item.value));
    },
    addStore() {
      this.editingStoreClone = {
        isMultiple: false,
        selection: [],
        comment: '',
        cost: 0,
        id: 0,
        destinationWarehouse: '',
        destinationWarehouseId: 0,
        dt: this.dataObj.appData.startDt,
        inventoryId: 0,
        inventoryName: '',
        sourceWarehouse: '',
        sourceWarehouseId: 0,
        stockQuantity: 0,
        takenQuantity: 0,
        total: 0,
        usedQuantity: 0,
        uuid: uuidv4(),
        stations: this.dataObj.appData.stations
      };
      this.editingStoreClone.warehouses = this.warehouses.filter((w) => w.group.id == this.dataObj.appData.stationId || w.selected);
      this.editingStoreClone.inventories = this.inventories;
      this.editingStoreClone.inventoryGroups = this.inventoryGroups;
      this.bStoreDialog = true;
    },
    editStore(item) {
      this.editingStore = item;
      this.editingStoreClone = JSON.parse(JSON.stringify(item));
      this.editingStoreClone.warehouses = this.warehouses.filter((w) => w.group.id == this.dataObj.appData.stationId || w.selected);
      this.editingStoreClone.inventories = this.inventories;
      this.editingStoreClone.inventoryGroups = this.inventoryGroups;
      this.editingStoreClone.isMultiple = false;
      this.editingStoreClone.total = item.total;
      this.editingStoreClone.cost = item.cost;
      this.editingStoreClone.selection = [];

      this.bStoreDialog = true;
    },
    removeConfirm(item) {
      this.deleteConfirmMessage = this.$t('omApplication.DeleteStore') + ' [' + item.inventoryId + '. ' + item.inventoryName + '] ?';
      this.editingStore = item;
      this.bConfirmDialog = true;
    },
    removeStore() {
      this.dataObj.appData.stores = this.dataObj.appData.stores.filter((p) => p.uuid !== this.editingStore.uuid);
      this.stores = this.dataObj.appData.stores;
    },
    saveStore() {
      //error traps
      if (!this.editingStoreClone.takenQuantity || this.editingStoreClone.takenQuantity <= 0) {
        this.$alertMsg(this.$t('validation.TakenLessZeroError'));
        return;
      }

      if (this.inventory > parseFloat(this.editingStoreClone.takenQuantity)) {
        this.$alertMsg(this.$t('validation.qtyUsedGreaterQtyTaken'));
        return;
      }

      if (!this.editingStoreClone.inventoryId || this.editingStoreClone.inventoryId < 0) {
        this.$alertMsg(this.$t('validation.invItemError'));
        return;
      }

      if (
        this.editingStoreClone.takenQuantity > 0 &&
        (!this.editingStoreClone.usedQuantity ||
          this.editingStoreClone.usedQuantity < 0 ||
          this.editingStoreClone.usedQuantity > this.editingStoreClone.takenQuantity)
      ) {
        this.$alertMsg(this.$t('validation.takenError'));
        return;
      }

      if (!this.editingStoreClone.usedQuantity || this.editingStoreClone.usedQuantity < 0) {
        this.$alertMsg(this.$t('validation.qtyError'));
        return;
      }

      if (!this.editingStoreClone.destinationWarehouseId || this.editingStoreClone.destinationWarehouseId < 0) {
        this.$alertMsg(this.$t('validation.warehouseError'));
        return;
      }

      if (!this.editingStoreClone.sourceWarehouseId || this.editingStoreClone.sourceWarehouseId < 0) {
        this.$alertMsg(this.$t('validation.warehouseError'));
        return;
      }

      this.dataObj.appData.stores = this.dataObj.appData.stores.filter((p) => p.uuid !== this.editingStoreClone.uuid);
      const isMultiple = this.editingStoreClone.isMultiple;
      const selection = this.editingStoreClone.selection;
      delete this.editingStoreClone.warehouses;
      delete this.editingStoreClone.inventories;
      delete this.editingStoreClone.inventoryGroups;
      if (isMultiple === false) {
        this.dataObj.appData.stores.push(this.editingStoreClone);
      } else {
        selection.forEach((p) => {
          const store = JSON.parse(JSON.stringify(this.editingStoreClone));
          const inventory = this.inventories.filter((e) => e.id === p)[0];
          store.inventoryId = p;
          store.inventoryName = inventory.name;
          store.uuid = uuidv4();
          this.dataObj.appData.stores.push(store);
        });
      }
      this.stores = this.dataObj.appData.stores;
      this.bStoreDialog = false;
    },
    closeDialog() {
      this.bStoreDialog = false;
    }
  }
};
